import { z } from 'zod';

export const ProvisionUserSchema = z.object({
  userId: z.string(),
});
export type ProvisionUserData = z.infer<typeof ProvisionUserSchema>;
